import _ from 'lodash';

import commonErrors from './commonErrors';

// This is purposefully kind of loose, because we don't want error handling
// code to throw errors.
export const toErrors = (errors: any) => {
  if (!errors) {
    console.warn("Don't try to create errors from a falsy value.");
    return [];
  }
  // Passed in a response.
  if (errors.responseText) {
    errors = errors.responseText;
  }
  // Passed in response text.
  if (_.isString(errors)) {
    try {
      const envelope = JSON.parse(errors);
      errors = envelope.errors;
    } catch (e) {
      console.warn('Unable to parse errors: ', errors);
      return [];
    }
  }
  if (!errors) {
    console.warn("Don't try to create errors from a falsy value.");
    return [];
  }
  // Passed in a parsed envelope.
  if (errors.errors) {
    errors = errors.errors;
  }
  if (!_.isArray(errors)) {
    console.warn('Not an errors array: ', errors);
    return [];
  }
  return errors;
};

export const hasErrorsOfType = (type: string, errors: any) => {
  errors = toErrors(errors);
  return errors.some((error: any) => error.type === type);
};

export const selectErrorsOfType = (type: string, errors: any) => {
  errors = toErrors(errors);
  return errors.filter((error: any) => error.type === type);
};

export const selectErrorOfType = (type: string, errors: any) =>
  selectErrorsOfType(type, errors)[0];

export const isPermanentError = (error: any) => {
  if (!error) {
    return false;
  }

  const type = commonErrors[error.name];
  return Boolean(type && type.isPermanent(error));
};

const selectErrorMessage = (error: Error | string) => {
  if (!error) {
    return '';
  }

  const message = _.isString(error) ? error : error.message;
  return message || '';
};

export const selectErrorMessages = (errors: Array<Error | string>) => {
  return errors
    .map(error => selectErrorMessage(error))
    .filter(message => message);
};
